import Confirm from './Confirm';
import ConfirmButton from './ConfirmButton';
import SurveyForm from './SurveyForm';
import SurveyFormTwo from './SurveyFormTwo';
import SurveyFormColumn from './SurveyFormColumn';
import SurveyFormRecheckSave from './SurveyFormRecheckSave';

const MuiDialog = {
  Confirm,
  ConfirmButton,
  SurveyForm,
  SurveyFormTwo,
  SurveyFormColumn,
  SurveyFormRecheckSave,
};

export default MuiDialog;
